import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitTemplateChecklist } from "../api/submit-template-checklist";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function TemplateChecklistFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");
	const navigate = useNavigate();
	const location = useLocation();

	const submitChecklist = useSubmitTemplateChecklist(
		order.details.retailOrderID,
		(result) => {
			showSuccessMessage("Template Checklist has been submitted");

			const newActionRequiredID = result.activeARs.find(x => x == 120);
			const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : '');

			if (newActionRequiredID && location.pathname !== to) {
				navigate(to);
			}
			else {
				refetchOrder();
			}
		},
		(error) => showErrorMessage(error)
	);

	return (
		<RetailOrderFiles
			fileTypes={[FileTypes.TemplateChecklist]}
			defaultFileType={FileTypes.TemplateChecklist}
			buttonCaption={order.details.activeARs.includes(AR.CfiToUploadTemplateChecklist) ?
				'Upload Template Checklist' : undefined}
			onFileAdded={(fileType: FileTypes) => {
				if (fileType === FileTypes.TemplateChecklist) {
					confirm("Do you want to submit the file?", "Submit File")
						.then((result) => {
							if (result) {
								submitChecklist.mutate();
							}
						});
				}
			}}
		/>
	)
}
